export default {
  citiesServed: [],
  selectedCity: [],
  addCity: {},
  countries: [],
  cities: [],
  citiesID: [],
  deleteCity: {},
  distributionCenters: [],
  zones: [],
  slotTime: [],
  matrixType: [],
  routingParameters: [],
  parameterTypes: [],
  addParameter: {},
  addMainParameter: {},
  parameterById: [],
  parameterCategories: [],
  mainParameters: [],
  editParamater: [],
  deleteParameter: {},
  showParameters: [],
  parameterProfiles: [],
  parameterProfile: {},
  users: [],
  addZone: {},
  subZones: [],
  editZone: [],
  userStores: [],
  userRegions: [],
  stores: [],
  firms: [],
  firmPaymentTypes: [],
};
